import ReactGA from "react-ga4";

const login = () => {
  ReactGA.event("login", {
    screen_name: document.title,
    page_location: document.location.href,
  });
};
const forgotPassword = () => {
  ReactGA.event("forgot_pass", {
    screen_name: document.title,
    page_location: document.location.href,
  });
};
const newAccount = () => {
  ReactGA.event("new_account", {
    screen_name: document.title,
    page_location: document.location.href,
  });
};

const viewProductKey = (productName, productKey, licId) => {
  ReactGA.event("view_product_key", {
    product_name: productName,
    product_key: productKey,
    lic_id: licId,
    screen_name: document.title,
    page_location: document.location.href,
  });
};
const copyProductKey = (productName, productKey, licId) => {
  ReactGA.event("copy_product_key", {
    product_name: productName,
    product_key: productKey,
    lic_id: licId,
    screen_name: document.title,
    page_location: document.location.href,
  });
};
const installProduct = (productName, urlInstall) => {
  ReactGA.event("install_product", {
    product_name: productName,
    url_install: urlInstall,
    screen_name: document.title,
    page_location: document.location.href,
  });
};

export default {
  login,
  forgotPassword,
  newAccount,
  viewProductKey,
  copyProductKey,
  installProduct,
};
